import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from "vue";
import type { SizeType } from "ant-design-vue/es/config-provider";

interface Props {
  modelValue?: number | null;
  placeholder?: string;
  disabled?: boolean;
  size?: SizeType;
  allowClear?: boolean;
  status?: "" | "error" | "warning";
  min?: number;
  max?: number;
  decimal?: number;
  currency?: string;
  showSuffix?: boolean;
  prefixIcon?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CurrencyInput',
  props: {
    modelValue: { default: null },
    placeholder: { default: "Nhập số tiền" },
    disabled: { type: Boolean, default: false },
    size: { default: "middle" },
    allowClear: { type: Boolean, default: true },
    status: { default: "" },
    min: { default: 0 },
    max: { default: Number.MAX_SAFE_INTEGER },
    decimal: { default: 0 },
    currency: { default: "₫" },
    showSuffix: { type: Boolean, default: true },
    prefixIcon: { default: "" }
  },
  emits: ["update:modelValue", "blur", "pressEnter", "change"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const displayValue = ref("");

const clamp = (num: number) => {
  let value = num;
  if (value < props.min) value = props.min;
  if (value > props.max) value = props.max;
  return value;
};

const parseNumber = (value: string): number | null => {
  if (!value || !String(value).trim()) return null;

  let raw = String(value)
    .replace(/[^\d.,]/g, "")
    .replace(/\./g, "")
    .replace(",", ".");

  if (!raw || raw === ".") return null;

  const num = Number(raw);
  if (Number.isNaN(num)) return null;
  return clamp(num);
};

const formatCurrency = (value: number | null): string => {
  if (value === null || value === undefined || Number.isNaN(value)) return "";
  return value.toLocaleString("vi-VN", {
    minimumFractionDigits: props.decimal,
    maximumFractionDigits: props.decimal,
  });
};

watch(
  () => props.modelValue,
  (val) => {
    displayValue.value = formatCurrency(val);
  },
  { immediate: true }
);

const onInput = (val: string) => {
  // Cho phép gõ tự do, chỉ giữ số và dấu phân cách
  displayValue.value = String(val).replace(/[^\d.,]/g, "");
  const parsed = parseNumber(displayValue.value);
  emit("update:modelValue", parsed);
  emit("change", parsed);
};

const onBlur = (e: FocusEvent) => {
  const parsed = parseNumber(displayValue.value);
  displayValue.value = formatCurrency(parsed);
  emit("update:modelValue", parsed);
  emit("blur", e);
};

const onPressEnter = (e: KeyboardEvent) => emit("pressEnter", e);

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createBlock(_component_a_input, {
    value: displayValue.value,
    "onUpdate:value": [
      _cache[0] || (_cache[0] = ($event: any) => ((displayValue).value = $event)),
      onInput
    ],
    placeholder: _ctx.placeholder,
    disabled: _ctx.disabled,
    size: _ctx.size,
    "allow-clear": _ctx.allowClear,
    status: _ctx.status,
    "addon-after": _ctx.showSuffix ? _ctx.currency : undefined,
    class: "ant-currency-input",
    onBlur: onBlur,
    onPressEnter: onPressEnter
  }, _createSlots({ _: 2 }, [
    (_ctx.prefixIcon)
      ? {
          name: "prefix",
          fn: _withCtx(() => [
            _createElementVNode("i", {
              class: _normalizeClass(_ctx.prefixIcon)
            }, null, 2)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["value", "placeholder", "disabled", "size", "allow-clear", "status", "addon-after"]))
}
}

})